
const SCROLL_CHILD = 'scrollChild'
export const CAROUSEL_SCROLL = `carouselScroll__${SCROLL_CHILD}`
export const ANCHOR_SCROLL = `anchorScroll__${SCROLL_CHILD}`
export const VERSE_SCROLL = `verseScroll__${SCROLL_CHILD}`
